import { Injectable } from "@angular/core";
import { ApiService } from "../../api/api.service";
import {
  IPartnerApiData,
  IPartnerListReq,
} from "../../../_models/partner.model";
import { HttpParams } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class PartnerService {
  constructor(private apiService: ApiService) {}

  getAll(req: IPartnerListReq) {
    let params = new HttpParams()
      .set("page", String(req.page))
      .set("limit", String(req.limit));

    if (req.status) {
      params = params.set("status", req.status.toLowerCase());
    }
    if (req.search) {
      params = params.set("search", req.search);
    }
    if (req.sort) {
      params = params.set("sortBy", req.sort);
    }
    if (req.sortOrder) {
      params = params.set("sortOrder", req.sortOrder);
    }

    return this.apiService.get<IPartnerApiData>({
      Url: "dating/admin/partner/applications",
      Params: params,
    });
  }

  acceptRequest(id: string, notes: string) {
    let params = new HttpParams({
      fromObject: {
        applicationId: id,
        adminNotes: notes,
      },
    });

    return this.apiService.put<unknown, IPartnerApiData>({
      Url: "dating/admin/partner/applications/approve",
      Params: params,
      Body: {},
    });
  }

  rejectRequest(id: string, notes: string) {
    let params = new HttpParams({
      fromObject: {
        applicationId: id,
        adminNotes: notes,
      },
    });

    return this.apiService.put<unknown, IPartnerApiData>({
      Url: "dating/admin/partner/applications/reject",
      Params: params,
      Body: {},
    });
  }
}
